import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { LANGS, T } from "./translations";

const LangCtx = createContext(null);

const STORAGE_KEY = "sal_lang";

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState("de");

  useEffect(() => {
    const stored = typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
    if (stored && T[stored]) setLangState(stored);
  }, []);

  const setLang = (l) => {
    if (!T[l]) return;
    setLangState(l);
    localStorage.setItem(STORAGE_KEY, l);
  };

  const value = useMemo(
    () => ({
      lang,
      setLang,
      langs: LANGS,
      t: T[lang] || T.de,
    }),
    [lang]
  );

  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LangCtx);
  if (!ctx) throw new Error("useLang must be used within <LangProvider>");
  return ctx;
};
